import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {Modal, Button, Form, FormGroup, FormControl} from 'react-bootstrap';
import authHeader from "../services/AuthHeader";
import SimpleReactValidator from 'simple-react-validator';

const EditCandidateModal = (props) => {
    let initValue = {
        ballotCandidateCandidateName: ''
    };

  const [user, setUser] = useState(initValue);
  const [hasChanged, setHasChanged] = useState(false);
  const [starId, setCandidateStarId] = useState();

  const simpleValidator = useRef(new SimpleReactValidator({className: "text-danger"}));
  const [showSubmit,setShowSubmit] = useState(true);
  let allValid = simpleValidator.current.allValid();

  useEffect(() => {
    setUser({
        starId: props.user.starId,
      });
    setCandidateStarId(props.user.starId);
  }, [props.user]);

  useEffect(() => {
    if (allValid) {
      setShowSubmit(false);
    } else {
      setShowSubmit(true);
    }
  }, [allValid]);


  const submitHandler = (e) => {
    e.preventDefault();

    async function doAction(){
      if (hasChanged === true) {
        /*put request when mode == "EDIT"*/
        if (props.mode === 'EDIT') {
          axios
            .put(
              process.env.REACT_APP_API_BASE + 'candidate/' + props.user.starId,
              user, { headers: authHeader() }
            )
            .then((res) => props.setRerender(true));
        }
      /*post request when mode == "ADD"*/
  
      if (props.mode === 'ADD') {
        axios
          .post(process.env.REACT_APP_API_BASE + 'candidate/', user, { headers: authHeader() })
          .then((res) => props.setRerender(true));
      }
    }
  
    setHasChanged(false);
    setUser(initValue);
    setCandidateStarId('');
  };
    doAction();

  };

  const handleChange = function (varName, e) {
    setHasChanged(true);
    const { value } = e.target;   
    setUser((state) => ({ ...state, [varName]: value }));
    };

  const handleClick = function () {
    setHasChanged(true);
    axios
        .get(
            process.env.REACT_APP_API_BASE + 'candidate/'+ user.starId,{ headers: authHeader() }
        )
        .then((res) => {
            const candidate = {
                BallotCandidateId: props.user.ballotCandidateId,
                StarId: user.starId,
                CandidateEmail: res.data.candidateEmail
            }

            axios
            .put(
            process.env.REACT_APP_API_BASE + 'candidate/' + props.user.candidateId,
            candidate, { headers: authHeader() }
            )
            .then((res) => props.setRerender(true));
        });
      setUser((state) => ({ ...state }));
    props.onHide();
  };

  const handleBack = function () {
    setCandidateStarId('');
    setUser(initValue);
    props.onHide();
  }

  let cCandidateStarId = user.starId;
  
  const { setRerenderListings, ...modalProps } = props;
  return (
    <Modal
      {...modalProps}
      size='lg'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>
          Edit Candidate
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={submitHandler}>
          <FormGroup controlId='starId'>
            <FormControl
              placeholder='Candidate StarId'
              defaultValue={starId}
              aria-label='Candidate Star ID'
              onChange={(e) => handleChange('starId', e)}
              autoComplete='off'
              name='starId'
              onBlur={simpleValidator.current.showMessageFor('starId')} 
              />
            {simpleValidator.current.message('starId',cCandidateStarId, 'alpha_num')}
          </FormGroup>
          
          <Button
            className='btn btn-default'
            type='submit'
            onClick={handleClick}
            disabled={showSubmit}
          >
            Save
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleBack}>Back</Button>
      </Modal.Footer>
    </Modal>
  );

};

export default EditCandidateModal;
